import initCarousel from '../helpers/carousel';
import { unitlessBreakpoints } from '../helpers/breakpoints';

export default class DynamicMediaWProducts {
  constructor(section) {
    this.el = section.el;

    initCarousel(
      this.el,
      {
        perPage: 2,
        perMove: 1,
        gap: '0.5rem',
        pagination: false,
        mediaQuery: 'min',
        breakpoints: {
          [unitlessBreakpoints.md]: {
            perPage: 1,
            gap: '3rem',
            padding: {
              left: '3rem',
              right: '3rem',
            },
          },
          [unitlessBreakpoints.xl]: {
            perPage: 2,
            gap: '1rem',
            padding: 0,
          },
        },
      },
      true,
    );
  }
}
